import React from 'react';
import { Callout, Link, UtilityInfoIcon } from '@placer-ui/components';
import { ControlledTextArea } from 'features/offline-reports/support-requests/components/support-requests-modals/components/inputs/controlled-textarea';
import { ControlledFileUpload } from 'features/offline-reports/support-requests/components/support-requests-modals/components/inputs/controlled-file-upload';
import styles from './request-market.module.scss';

const MAX_INFORMATION_LENGTH = 1000;
const SUPPORTED_FILE_TYPES = [
    '.kmz', // KMZ (compressed KML)
    '.kml', // KML (Google Earth format)
    'application/pdf', // PDF (Portable Document Format)
    'application/zip', // SHP ZIP (Shapefile archive)
    'application/x-zip',
    'application/x-zip-compressed',
    'application/geo+json',
    '.geojson',
];

export const FileRequestMarket = () => {
    return (
        <>
            <ControlledTextArea
                name="information"
                initialHeight={104}
                maxLength={MAX_INFORMATION_LENGTH}
                label="Information"
                data-testid="market-information-input"
                feedback={[
                    {
                        message: `Up to ${MAX_INFORMATION_LENGTH} characters`,
                        state: 'guidance',
                        hideIcon: true,
                    },
                ]}
                placeholder="Share additional details to help our support team assist you better (optional)"
            />
            <ControlledFileUpload
                name="files"
                testId="market-files-input"
                label="Attachments"
                formats={SUPPORTED_FILE_TYPES}
                description="ZIP (SHP file), KMZ, KML, GeoJSON"
                feedback={[]}
                required
                asterix
            />
            <div className={styles.callout}>
                <Callout
                    FreeTextIcon={<UtilityInfoIcon />}
                    text="A KML or SHP zip file is needed for POIs without official map boundaries. View how to create a KML in"
                    CTA={
                        <>
                            <Link
                                target="_blank"
                                href="https://view-su2.highspot.com/viewer/665ed3e5b6fab709cabf5542"
                            >
                                Google Maps
                            </Link>
                            &nbsp; or &nbsp;
                            <Link
                                target="_blank"
                                href="https://view-su2.highspot.com/viewer/665ed47d96e761295ee17d8c"
                            >
                                Google Earth
                            </Link>
                        </>
                    }
                />
            </div>
        </>
    );
};
